import { render, staticRenderFns } from "./SupplierAdmin.vue?vue&type=template&id=75316d16&scoped=true&"
import script from "./SupplierAdmin.vue?vue&type=script&lang=js&"
export * from "./SupplierAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SupplierAdmin.vue?vue&type=style&index=0&id=75316d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75316d16",
  null
  
)

export default component.exports